import React, { Component } from 'react';

import { reduxForm, Field } from 'redux-form';
import { TextField } from 'redux-form-material-ui';

import FlatButton from 'material-ui/FlatButton';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';

class CompanyLandlordWebSolutionsForm extends Component {
  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <div
          className="row"
          style={{
            marginTop: '15px',
            textAlign: 'justify',
            fontSize: '14px',
            marginBottom: '15px',
          }}
        >
          {getTranslatedString('landLordPortal.companyLandLordWebSolutionsForm.pleaseProvide')}
        </div>
        <div className="row" style={{ marginTop: '15px', marginBottom: '15px' }}>
          <div className="col-sm-12">
            <Field
              name="landlord_web_solutions_client_id"
              component={TextField}
              floatingLabelText={getTranslatedString(
                'landLordPortal.companyLandLordWebSolutionsForm.labelText'
              )}
              multiLine={false}
              fullWidth
              style={{ marginTop: '-15px', fontSize: '14px' }}
            />
          </div>
        </div>
        <div className="row" style={{ textAlign: 'center', marginBottom: '15px' }}>
          <FlatButton
            variant="raised"
            disabled={this.props.submitting}
            onClick={() => this.props.handleSubmit()}
            style={{
              color: 'white',
              backgroundColor: this.props.submitting ? colors.LIGHT_GRAY : AccentColor(),
            }}
          >
            {getTranslatedString('landLordPortal.companyLandLordWebSolutionsForm.update')}
          </FlatButton>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'landlord_web_solutions',
  enableReinitialize: true,
})(CompanyLandlordWebSolutionsForm);
